import Navbar from './Navbar';
import './Navbar.scss';

export default Navbar;
